module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./destinationResultsDate.schema.json"));
	}, "validators");
}


//////////////////
// WEBPACK FOOTER
// ./src/widget/destinationResultsDate.schema.json
// module id = 243
// module chunks = 1